import { faShapes } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  BackButton,
  Container,
  FullLoadingIndicator,
  Page,
  PageTitle,
  SubTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import {
  useOrganization,
  useTeam,
} from '@foxtrotplatform/platform-micro-site-core';
import { Button } from '@windmill/react-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getOrganizationApplications } from '../../common/api/application';
import { setApplications } from '../../common/reducers/applicationSlice';
import { ApplicationTable } from './ApplicationTable';

export const ApplicationCheck: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentOrg, isOrganizationsReady } = useOrganization();
  const { currentTeam } = useTeam();
  const orgApplications: Application[] = useSelector<AppState, Application[]>(
    ({ applications }) => {
      return applications;
    }
  );
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (
      currentOrg &&
      isOrganizationsReady &&
      currentTeam &&
      currentTeam.orgId === currentOrg.id
    ) {
      const getOrgApps = async () => {
        const orgApps = await getOrganizationApplications(
          currentOrg.id,
          currentTeam.id
        );

        if (orgApps) {
          dispatch(setApplications(orgApps));
        }
        setIsLoading(false);
      };
      getOrgApps();
    }
  }, [currentOrg, isOrganizationsReady, currentTeam]);

  const onRegisterAnAppClicked = React.useCallback(
    () => navigate('/application/create'),
    [navigate]
  );

  if (isLoading) {
    return (
      <Page>
        <Container className="p-0" size="medium">
          <FullLoadingIndicator
            contentClassName="flex flex-col justify-center items-center font-bold text-2xl h-128 p-os1-spacing"
            fullWidth={false}
            underHeader={true}
          />
        </Container>
      </Page>
    );
  }

  return (
    <Page>
      <Container size="medium">
        <div className="flex flex-row justify-between items-center mb-os1-spacing">
          <div className="flex flex-row items-center gap-x-3">
            <BackButton />
            <PageTitle>Apps</PageTitle>
          </div>
          {orgApplications && orgApplications.length > 0 ? (
            <Button
              className="h-10"
              onClick={() => navigate('/application/create', { replace: true })}
              size="large"
            >
              Register Additional Apps
            </Button>
          ) : null}
        </div>
        {orgApplications && orgApplications.length > 0 ? (
          <ApplicationTable applications={orgApplications} />
        ) : (
          <div className="flex flex-col items-center">
            <div className="flex flex-row justify-around items-center h-16 w-16 bg-gray-50">
              <FontAwesomeIcon className="h-12 w-12" icon={faShapes} />
            </div>
            <SubTitle className="my-5">You have not created any apps</SubTitle>
            <Button onClick={onRegisterAnAppClicked} size="large">
              <FontAwesomeIcon className="pr-3 text-white" icon={faPlus} />
              Create Your First App
            </Button>
          </div>
        )}
      </Container>
    </Page>
  );
};
